import { Tooltip } from "@mui/material";
import React from "react";
import JoinNowbtn from "../DCM/components/PopUp/buttons/JoinNowbtn";
import TimeTableJoinNow from "../DCM/components/day-event/Time-table-join-now";

function UpcomingMainContent({
  obj,
  handleOpenPopup,
  reduceParagraphLength,
  formatTime,
  formatDateNew,
  events,
  fromHomePage,
}) {
  const today = new Date().toISOString().split("T")[0]; // Format: YYYY-MM-DD

  // Determine the text color based on the date

  const currentTime = new Date();

  // determines if event is after currently happening based on current time
  const isHappened = currentTime.getTime() > event?.EndTime?.getTime();

  // determines if event is currently happening based on current time
  const isEventHappening =
    currentTime.getTime() >= event?.StartTime?.getTime() &&
    currentTime.getTime() <= event?.EndTime?.getTime();
  const textColor = obj?.date === today ? "#1D631D" : "#3d348b";
  return (
    <div className="upcoming-main-content">
      <div className="upcoming-content-text" style={{ color: textColor }}>
        <div className="todayHistoryText">
          <Tooltip
            title={obj?.name}
            arrow
            placement="top"
            enterDelay={200}
            leaveDelay={100}
          >
            <div style={{ color: textColor }}>
              {reduceParagraphLength(obj?.name, 25)}
            </div>
          </Tooltip>
        </div>
        <Tooltip
          title={obj?.subject?.name}
          arrow
          placement="bottom"
          enterDelay={200}
          leaveDelay={100}
        >
          <div className="todayHistoryText" style={{ color: textColor }}>
            {reduceParagraphLength(obj?.subject?.name, 25)}
          </div>
        </Tooltip>
      </div>
      <div className="TeacherNameClass" style={{ color: textColor }}>
        <div>
          {formatTime(obj?.start_time)} - {formatTime(obj?.end_time)}
        </div>
        <div className="up-date">{formatDateNew(obj?.date)}</div>
      </div>
      <div className="TeacherNameClass" style={{ color: textColor }}>
        {obj?.teacher?.name}
      </div>
      {obj.supplements?.bbb_lecture && (
        <div className="TeacherNameClass" style={{ color: textColor }}>
          <TimeTableJoinNow
            event={events}
            obj={obj}
            fromHomePage={fromHomePage}
          />
        </div>
      )}
      <div
        className="lecture-ins-text"
        onClick={
          !obj?.supplements || !obj?.supplements?.lecInstruction
            ? undefined
            : () => handleOpenPopup(obj?.supplements?.lecInstruction, obj?.name)
        }
        style={{ color: textColor }}
      >
        {!obj?.supplements || !obj?.supplements?.lecInstruction ? (
          <div
            className="no-lec-Inst-text"
            style={{ color: textColor, opacity: "0.5", cursor: "not-allowed" }}
          >
            No lecture Instruction Available!
          </div>
        ) : (
          <div>
            {reduceParagraphLength(obj?.supplements?.lecInstruction, 50)}
          </div>
        )}
      </div>
    </div>
  );
}

export default UpcomingMainContent;
